module.exports = __webpack_public_path__ + "media/images/checked-checkbox-7d08435b1634f447fa4284ec8aa4558f652e952feb55bdd8d8d7fbd111b7efc4.svg";